import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { scheduleOnce } from '@ember/runloop';
import { htmlSafe } from '@ember/template';
import { tracked } from '@glimmer/tracking';

import type { PopupData } from 'webapp-types';
import { getWidescreenSizeThatFits } from 'webapp/utils/html';

import onWindowEvents from 'webapp/modifiers/on-window-events';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class CommonPopupsVideoComponent extends PopupInnerModalComponent<PopupData.Common.Video> {
	@tracked width = 540;
	@tracked height = 304;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.resize();
	}

	get autoplay() {
		return this.popupData.autoplay ?? false;
	}

	get url() {
		const baseUrl = this.popupData.url;
		if (this.autoplay) {
			const separator = baseUrl.includes('?') ? '&' : '?';
			return `${baseUrl}${separator}autoplay=1`;
		}
		return baseUrl;
	}

	get videoStyle() {
		return htmlSafe(`width:${this.width}px;height:${this.height}px;`);
	}

	@action
	resize() {
		const videoExtrasHeight = 25; // close button

		// calculate width that fits the window
		const size = getWidescreenSizeThatFits(
			window.innerWidth * 0.9, // margins
			window.innerHeight * 0.9, // margins
			videoExtrasHeight,
		);

		this.width = size.width;
		this.height = size.height;

		scheduleOnce('afterRender', this, this.reposition);
	}
	<template>
		<div class="content" {{onWindowEvents this.resize "resize" 200}}>
			<div class="video" style={{this.videoStyle}}>
				<iframe
					title="Databox video guide"
					src={{this.url}}
					width="100%"
					height="100%"
					frameborder="0"
					allow={{if this.autoplay "autoplay"}}
					allowfullscreen
				></iframe>
			</div>
		</div>
	</template>
}
